import React, {useMemo} from "react";

import {TextMarker} from "./TextMarker";
import {formatCoordinate} from "../formatCoorindate";

/**
 * Shows a text marker indicating the x, z coordinate at each grid corner.
 */
export const GridCornerMarkers: React.FC<{ gridRadius: number }> = ({gridRadius}) => {
  const formatted = useMemo(() => formatCoordinate(gridRadius), [gridRadius]);
  return <>
    <TextMarker position={[5, 0, 5]} text={`${formatted} , ${formatted}`}/>
    <TextMarker position={[-5, 0, 5]} text={`-${formatted} , ${formatted}`}/>
    <TextMarker position={[5, 0, -5]} text={`${formatted} , -${formatted}`}/>
    <TextMarker position={[-5, 0, -5]} text={`-${formatted} , -${formatted}`}/>
  </>;
};